import { Component, PropsWithChildren } from 'react'

type ErrorState = {
  hasError: boolean
  error?: Error
}

export class ErrorBoundary extends Component<PropsWithChildren, ErrorState> {
  constructor(props: PropsWithChildren) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error }
  }

  render() {
    if (this.state.hasError) {
      if (!this.state.error) {
        return <div />
      }
      return (
        <div className='error'>
          <div style={{ marginBottom: 10 }}>
            <h3>Something went wrong...</h3>
            <p className='small'>We encounted an unexpected issue.</p>
          </div>
          <span className='micro'>{String(this.state.error)}</span>
        </div>
      )
    }

    return this.props.children
  }
}
